import {Locales} from '@netx/core-next/locales';
import {UploadAssetRequestField, UploadAssetRequestStatus} from './schema';

export const UploadAssetRequestsManageLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.uploadRequests'),
	DUPLICATE: i18n('i18n.duplicate'),
	OPTIONAL: i18n('i18n.optional'),
	COPY_LINK: i18n('i18n.copyLink'),
	ADD: i18n('i18n.addUploadRequest'),
	DELETE: i18n('i18n.delete'),
	EDIT: i18n('i18n.edit'),
	STATUS: i18n('i18n.status'),
	SHARE: i18n('i18n.share'),
}));

export const UploadAssetRequestMessage = Locales((i18n) => ({
	ERROR: i18n('i18n.error'),
	CONFIRM_DELETE: i18n('i18n.actionPermanent'),
	NO_MATCHING_RECORDS: i18n('i18n.noRecords'),
	NO_RECORDS: i18n('i18n.emptyUploadRequestsList'),
	CATEGORY_MISSING: i18n('i18n.uploadAssetRequestDisabled_categoryMissing'),
	EXPIRED: i18n('i18n.uploadAssetRequestDisabled_expired'),
	USER_MISSING: i18n('i18n.uploadAssetRequestDisabled_userMissing'),
}));

export const UploadAssetRequestTitle = Locales((i18n) => ({
	UPLOAD_ASSET_REQUESTS: i18n('i18n.uploadRequests'),
	UPLOAD_ASSET_REQUEST: i18n('i18n.uploadRequest'),
	CONFIRM_DELETE: i18n('i18n.uploadAssetRequestDeleteConfirmTitle'),
}));

export const UploadAssetRequestSubTitle = Locales((i18n) => ({
	EDIT: i18n('i18n.edit'),
	NEW: i18n('i18n.new'),
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const UploadAssetRequestStatusLabel = Locales((i18n) => ({
	[UploadAssetRequestStatus.ACTIVE]: i18n('i18n.enabled'),
	[UploadAssetRequestStatus.USER_DISABLED]: i18n('i18n.disabled'),
	[UploadAssetRequestStatus.EXPIRED]: i18n('i18n.expired'),
	[UploadAssetRequestStatus.CATEGORY_RESOURCE_MISSING]: i18n(
		'i18n.invalidCategory',
	),
	[UploadAssetRequestStatus.USER_RESOURCE_MISSING]: i18n('i18n.invalidUser'),

	DISABLED: i18n('i18n.disabled'),
	ENABLED: i18n('i18n.enabled'),
	ANY: i18n('i18n.any'),
}));

export const UploadAssetRequestStep = Locales((i18n) => ({
	SETTINGS: i18n('i18n.settings'),
	ATTRIBUTES: i18n('i18n.attributes'),
	SHARE: i18n('i18n.share'),
}));

export const UploadAssetRequestActionLabel = Locales((i18n) => ({
	ADD: i18n('i18n.create'),
	BACK: i18n('i18n.back'),
	CANCEL: i18n('i18n.cancel'),
	NEXT: i18n('i18n.next'),
	SAVE: i18n('i18n.publish'),
	SHARE: i18n('i18n.share'),
	SKIP: i18n('i18n.close'),
}));

export const UploadAssetRequestSettingsTitle = Locales((i18n) => ({
	ENABLED: i18n('i18n.enableLink'),
	LINK: i18n('i18n.link'),
	TITLE: i18n('i18n.title'),
	CATEGORY: i18n('i18n.category'),
	ATTRIBUTES_ENABLED: i18n('i18n.allowAttributeEditing'),
	NOTIFY: i18n('i18n.notify'),
	EXPIRATION_DATE: i18n('i18n.expirationDate'),
}));

export const UploadAssetRequestSettingsDescription = Locales((i18n) => ({
	ENABLED: i18n('i18n.uploadAssetRequestSettingsDescription_enabled'),
	LINK: i18n('i18n.uploadAssetRequestSettingsDescription_link'),
	TITLE: i18n('i18n.uploadAssetRequestSettingsDescription_title'),
	CATEGORY: i18n('i18n.uploadAssetRequestSettingsDescription_category'),
	ATTRIBUTES_ENABLED: i18n(
		'i18n.uploadAssetRequestSettingsDescription_attributesEnabled',
	),
	NOTIFY: i18n('i18n.uploadAssetRequestSettingsDescription_notify'),
	EXPIRATION_DATE: i18n(
		'i18n.uploadAssetRequestSettingsDescription_expirationDate',
	),
}));

export const UploadAssetRequestColumnLabel = Locales<
	Partial<Record<keyof typeof UploadAssetRequestField, string>>
>((i18n) => ({
	[UploadAssetRequestField.attributeEditsEnabled]: i18n(
		'i18n.attributeEditsEnabled',
	),
	[UploadAssetRequestField.categoryId]: i18n('i18n.categoryId'),
	[UploadAssetRequestField.categoryName]: i18n('i18n.category'),
	[UploadAssetRequestField.categoryPath]: i18n('i18n.categoryPath'),
	[UploadAssetRequestField.creationDate]: i18n('i18n.created'),
	[UploadAssetRequestField.creatorUserId]: i18n('i18n.creatorUserId'),
	[UploadAssetRequestField.creatorUserLabel]: i18n('i18n.createdBy'),
	[UploadAssetRequestField.expirationDate]: i18n('i18n.expirationDate'),
	[UploadAssetRequestField.id]: i18n('i18n.id'),
	[UploadAssetRequestField.notifyId]: i18n('i18n.notifyId'),
	[UploadAssetRequestField.notifyLabel]: i18n('i18n.notify'),
	[UploadAssetRequestField.notifyType]: i18n('i18n.notifyType'),
	[UploadAssetRequestField.status]: i18n('i18n.status'),
	[UploadAssetRequestField.title]: i18n('i18n.title'),
	[UploadAssetRequestField.token]: i18n('i18n.token'),
}));
